import { useStoreRehydrated } from 'easy-peasy';
import React from 'react';

const PersistProvider: React.FC = ({ children }) => {
  const isRehydrated = useStoreRehydrated();
  return isRehydrated ? <>{children}</> : <div>Loading...</div>;
};

export default PersistProvider;
